import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import Login from './Components/Auth/Login';
import OTP from './Components/Auth/OTP';
import Appointments from './Components/Appointments/Appointments';
import Main from './Components/Main';
import Call from './Components/Appointments/Call';
import Patient_Profile from './Components/Appointments/Patient_Profile';
import Reports from './Components/Reports/Reports';
import UploadReports from './Components/Reports/UploadReports';
import ViewReportList from './Components/Reports/ViewReportList';
import ViewReport from './Components/Reports/ViewReport';
import Prescription from './Components/Prescription/Prescription';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UploadPrescription from './Components/Prescription/UploadPrescription';
import ViewPrescription from './Components/Prescription/ViewPrescription';
import Chat from './Components/Chat/Chat';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import Profile from './Components/Appointments/Profile';
import Reschedule from './Components/Appointments/Reschedule';
import PatientList from './Components/Appointments/PatientList';
import ChatPage from './Components/Chat/ChatPage';
import AllAppointments from './Components/Appointments/AllAppointmentsPage';
import EditProfile from "./Components/Appointments/EditProfile";
import AddUser from './Components/Appointments/AddUser';
import './Components/Auth/consentform.css'
import RecipeSuggestions from './Components/AI Suggestions/RecipeSuggestions';
import PrescriptionLayout from './Components/Prescription/PrescriptionLayout';
import LifeStylePracticesSuggestions from './Components/AI Suggestions/LifeStylePracticesSuggestions';
import MedicineRecommendations from './Components/AI Suggestions/MedicineRecommendation';
import DailyLogging from './Components/Recommendations/DailyLogging';
import PromotionUpload from './Components/Prescription/PromotionUpload';
import PatientUploadReport from './Components/Reports/PatientUploadReport';
import Settings from './Components/Settings/Settings';
import Cookies from 'js-cookie';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MaharishiQuizResult from './Components/Appointments/MaharishiQuizResult';
import HeartSessionResult from './Components/Appointments/HeartSessionResult';
import FacialLandmarkResult from './Components/Appointments/FacialLandmarkResult';
import QuestionAnswer from './Components/Appointments/QuestionAnswer';


function App() {

  const [muiTheme, setMuiTheme] = React.useState(createTheme({
    palette: {
      primary: { main: '#DA6E0B' },
      secondary: { main: '#75623F' },
      background: { default: '#FFFFFF', paper: '#FFFFFF' },
      text: { primary: '#75623F' }
    },
    typography: { fontFamily: "'Poppins', sans-serif" }
  }));

  const applyTheme = () => {
    const kioskDetailsCookie = Cookies.get('kiosk_details');
    if (kioskDetailsCookie) {
      try {
        const details = JSON.parse(kioskDetailsCookie);
        if (details.ThemeColors && Array.isArray(details.ThemeColors)) {
          let primary = '#DA6E0B';
          let secondary = '#75623F';
          let bg = '#FFFFFF';

          details.ThemeColors.forEach(color => {
            const htmlColor = color.val && color.val.startsWith('0xFF')
              ? '#' + color.val.substring(4)
              : color.val;
            if (htmlColor) {
              document.documentElement.style.setProperty(`--${color.key}`, htmlColor);
              if (color.key === 'themePrimaryColor') primary = htmlColor;
              if (color.key === 'themeSecondaryColor') secondary = htmlColor;
              if (color.key === 'themeBackgroundColor') bg = htmlColor;
            }
          });

          setMuiTheme(createTheme({
            palette: {
              primary: { main: primary },
              secondary: { main: secondary },
              background: { default: bg, paper: secondary },
              text: { primary: primary }
            },
            typography: { fontFamily: "'Poppins', sans-serif" }
          }));
        }
      } catch (error) {
        console.error('Error parsing kiosk_details cookie in App.js:', error);
      }
    }
  };

  useEffect(() => {
    applyTheme();
    window.addEventListener('themeChanged', applyTheme);
    return () => window.removeEventListener('themeChanged', applyTheme);
  }, []);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route path='/Login' Component={Login} />
          <Route path='/LoginwithOTP' Component={OTP} />

          {/* <Route path='/Consentform' element={<Consentform />}/> */}

          <Route path="/prescription" element={<ProtectedRoute><PrescriptionLayout /></ProtectedRoute>}>
            <Route index element={<UploadPrescription />} />
            <Route path='medicines' element={<MedicineRecommendations />} />
            <Route path="recipes" element={<RecipeSuggestions />} />
            <Route path="lifestylepractices" element={<LifeStylePracticesSuggestions />} />
          </Route>

          <Route path='/patient/upload-report/:id' element={<PatientUploadReport />} />

          <Route path='/' element={<ProtectedRoute><Home></Home></ProtectedRoute>} >
            <Route path='Recommendations' element={<ProtectedRoute><DailyLogging /></ProtectedRoute>} />
            <Route path='/' element={<ProtectedRoute><Main /></ProtectedRoute>} />
            <Route path='AllChat' element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
            <Route path='Appointments' element={<ProtectedRoute><Appointments></Appointments></ProtectedRoute>} />
            <Route path="AllAppointments" element={<AllAppointments />} />
            <Route path='Patientlist' element={<ProtectedRoute><PatientList /></ProtectedRoute>} />
            <Route path='AddUser' element={<ProtectedRoute><AddUser /></ProtectedRoute>} />
            <Route path='Reschedule/:id' element={<ProtectedRoute><Reschedule></Reschedule></ProtectedRoute>} />
            <Route path='Patient/:id' element={<ProtectedRoute><Patient_Profile /></ProtectedRoute>} />
            <Route path='Call/:id/:type' element={<ProtectedRoute><Call /></ProtectedRoute>} />
            <Route path='Reports/:id' element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path='/UploadReports/:id/:type' element={<ProtectedRoute><UploadReports /></ProtectedRoute>} />
            <Route path='/ViewReportList/:UID/:id' element={<ProtectedRoute><ViewReportList /></ProtectedRoute>} />

            <Route path='/ViewReport/:UID/:id/:key' element={<ProtectedRoute><ViewReport /></ProtectedRoute>} />
            <Route path='Precription' element={<ProtectedRoute><Prescription /></ProtectedRoute>} />
            <Route path="PromotionUpload" element={<ProtectedRoute><PromotionUpload /></ProtectedRoute>} />
            <Route path="Settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="ViewPrescription" element={<ProtectedRoute><ViewPrescription /></ProtectedRoute>} />
            <Route path="Chat/:Patient_id/:Doctor_id" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
            <Route path='/Profile' element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path='/AddUser' element={<ProtectedRoute><AddUser /></ProtectedRoute>} />
            <Route path='/MaharishiQuiz/:uid' element={<ProtectedRoute><MaharishiQuizResult /></ProtectedRoute>} />
            <Route path='/HeartAnalysis/:uid' element={<ProtectedRoute><HeartSessionResult /></ProtectedRoute>} />
            <Route path='/FacialAnalysis/:uid' element={<ProtectedRoute><FacialLandmarkResult /></ProtectedRoute>} />
            <Route path='/QuestionAnswer/:uid' element={<ProtectedRoute><QuestionAnswer /></ProtectedRoute>} />

          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;

